// Montants en millimes (entier) : jamais de float pour la monnaie.
declare const millimesBrand: unique symbol;
export type Millimes = number & { readonly [millimesBrand]: true };

export type Currency = 'TND';
export const DEFAULT_CURRENCY: Currency = 'TND';

export function toMillimes(value: number): Millimes {
  if (!Number.isSafeInteger(value)) {
    throw new RangeError(`Montant invalide : ${value} n'est pas un entier de millimes`);
  }
  return value as Millimes;
}

export function addMillimes(a: Millimes, b: Millimes): Millimes {
  return toMillimes(a + b);
}

export function subtractMillimes(a: Millimes, b: Millimes): Millimes {
  return toMillimes(a - b);
}
